<template>
  <section>
    <TopNavbar />
    <div class="wrapper">
      <AddEmployer />
    </div>
  </section>
</template>

<script>
import TopNavbar from '../../Navigations/TopNavbar';
import AddEmployer from './AddEmployerBtnModal';
export default {
  components: {
    TopNavbar,
    AddEmployer,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 80px 30px 0 30px;
}
</style>
